import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUserInfo } from '@api/user/useUserInfo';
import { Language, supportedLanguages } from '@configs/i18n';
import { AppHeader } from './AppHeader';

interface Props {
  onLanguageSelect: (lang: string) => void;
  navItems?: Array<{ id: string | number; name: string }>;
  onNavSelect?: (tabId: string | number) => void;
  activeNavItem?: string;
}

export const AppHeaderWrapper: React.FC<Props> = ({
  onLanguageSelect,
  navItems,
  onNavSelect,
  activeNavItem,
}) => {
  const { t: glossaryT, i18n } = useTranslation('glossary');
  const userInfoQuery = useUserInfo();

  const userName = userInfoQuery.data
    ? `${userInfoQuery.data.firstName} ${userInfoQuery.data.lastName}${
        userInfoQuery.data.customerType
          ? ` (${userInfoQuery.data.customerType})`
          : ''
      }`
    : '';

  return (
    <header>
      <AppHeader
        text={glossaryT('app.name')}
        currentLanguage={i18n.language as Language}
        onLanguageSelect={onLanguageSelect}
        languages={[...supportedLanguages]}
        userName={userName}
        customerType={userInfoQuery.data?.customerType ?? null}
        navItems={navItems}
        onNavSelect={onNavSelect}
        activeNavItem={activeNavItem}
      />
    </header>
  );
};
